/** Par módulo+acción para checks OR en pantallas compuestas. */
export type PermisoPar = Readonly<{ modulo: string; accion: string }>;

export type TienePermisoFn = (modulo: string, accion: string) => boolean;

/** Basta con uno de la lista (OR). */
export function tieneAlgunoPermiso(
  tiene: TienePermisoFn,
  requeridos: readonly PermisoPar[],
): boolean {
  if (!requeridos.length) return true;
  return requeridos.some((p) => tiene(p.modulo, p.accion));
}

/** GET /usuarios — pantalla Seguridad / selects opcionales. */
export const PERMISO_LISTAR_USUARIOS: readonly PermisoPar[] = [
  { modulo: 'SEGURIDAD', accion: 'VER' },
];

/** Listar pagos / abonos. */
export const PERMISO_LISTAR_PAGOS: readonly PermisoPar[] = [
  { modulo: 'CREDITOS', accion: 'VER' },
  { modulo: 'REPORTES', accion: 'VER' },
  { modulo: 'CAJA', accion: 'VER' },
];

/** Productos al crear crédito. */
export const PERMISO_LISTAR_PRODUCTOS_CREDITO: readonly PermisoPar[] = [
  { modulo: 'INVENTARIO', accion: 'VER' },
  { modulo: 'CREDITOS', accion: 'CREAR' },
];

/** Reportes de cartera / colocación / corte (supervisor o comité). */
export const PERMISO_REPORTES_CARTERA_O_COMITE: readonly PermisoPar[] = [
  { modulo: 'REPORTES', accion: 'VER' },
  { modulo: 'COMITE', accion: 'VER' },
];

/** Ruta de cobros de otro vendedor. */
export const PERMISO_RUTA_COBROS_SUPERVISOR: readonly PermisoPar[] = [
  { modulo: 'COBROS', accion: 'VER' },
  { modulo: 'REPORTES', accion: 'VER' },
];

/** Ruta desde cartera de trabajo / comité. */
export const PERMISO_RUTA_COBROS_COMITE: readonly PermisoPar[] = [
  { modulo: 'COBROS', accion: 'VER' },
  { modulo: 'COMITE', accion: 'VER' },
];

/** Corte diario de cobros. */
export const PERMISO_CORTE_COBROS: readonly PermisoPar[] = [
  { modulo: 'COBROS', accion: 'VER' },
  { modulo: 'REPORTES', accion: 'VER' },
  { modulo: 'COMITE', accion: 'VER' },
];
